const APP_VERSION = "1.32.124";
export default APP_VERSION;
